import {
    GET_PORTAL_LINKS,
    GET_PORTAL_LINKS_SUCCESS,
    GET_PORTAL_LINKS_FAIL,
    ADD_PORTAL_LINK,
    ADD_PORTAL_LINK_SUCCESS,
    ADD_PORTAL_LINK_FAIL,
    UPDATE_PORTAL_LINK,
    UPDATE_PORTAL_LINK_SUCCESS,
    UPDATE_PORTAL_LINK_FAIL,
    DELETE_PORTAL_LINK,
    DELETE_PORTAL_LINK_SUCCESS,
    DELETE_PORTAL_LINK_FAIL,
    SET_PORTAL_LINKS_FIELD_ERRORS,
  } from './actionTypes';
  
  // Get Portal Links
  export const getPortalLinks = (params) => ({
    type: GET_PORTAL_LINKS,
    payload: params,
  });
  
  export const getPortalLinksSuccess = (data) => ({
    type: GET_PORTAL_LINKS_SUCCESS,
    payload: data,
  });
  
  export const getPortalLinksFail = (error) => ({
    type: GET_PORTAL_LINKS_FAIL,
    payload: error,
  });
  
  // Add Portal Link
  export const addPortalLink = (data, resetForm, handleClose) => ({
    type: ADD_PORTAL_LINK,
    payload: { data, resetForm, handleClose },
  });
  
  export const addPortalLinkSuccess = (data) => ({
    type: ADD_PORTAL_LINK_SUCCESS,
    payload: data,
  });
  
  export const addPortalLinkFail = (error) => ({
    type: ADD_PORTAL_LINK_FAIL,
    payload: error,
  });
  
  // Update Portal Link
  export const updatePortalLink = (data, id, resetForm, handleClose) => ({
    type: UPDATE_PORTAL_LINK,
    payload: { data, id, resetForm, handleClose },
  });
  
  export const updatePortalLinkSuccess = (data) => ({
    type: UPDATE_PORTAL_LINK_SUCCESS,
    payload: data,
  });
  
  export const updatePortalLinkFail = (error) => ({
    type: UPDATE_PORTAL_LINK_FAIL,
    payload: error,
  });
  
  // Delete Portal Link
  export const deletePortalLink = (id) => ({
    type: DELETE_PORTAL_LINK,
    payload: id,
  });
  
  export const deletePortalLinkSuccess = (id) => ({
    type: DELETE_PORTAL_LINK_SUCCESS,
    payload: id,
  });
  
  export const deletePortalLinkFail = (error) => ({
    type: DELETE_PORTAL_LINK_FAIL,
    payload: error,
  });
  
  // Set Field Errors
  export const setPortalLinksFieldErrors = (errors) => ({
    type: SET_PORTAL_LINKS_FIELD_ERRORS,
    payload: errors,
  });
